"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  props: {},
  computed: {
    device: function device() {
      return this.$store.state.app.device;
    }
  },
  data: function data() {
    return {
      drawer: false
    };
  },
  methods: {
    switchType: function switchType(type) {
      this.$emit('switchType', type);
    }
  }
};